export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    default:
      return splitKey
  }
}
